import React, {useState, useCallback, useEffect, useMemo} from 'react';
import debounce from 'lodash.debounce';
import "./styles/style-duelist-filter.scss";
import {
    Button,
    Input,
    UncontrolledTooltip,
    Card,
    CardBody,
    FormGroup,
    Form,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Modal,
} from "reactstrap";
import classnames from "classnames";
// import Select2 from "react-select2-wrapper";
import Select2 from "react-select2-wrapper";
import DatePicker, { registerLocale } from "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "../../../../utils/conversor";
// import filterFields, { filterOnlyFields } from "../../../../services/duelistFilters";
import allFilterOptions from 'utils/filterFields';



registerLocale('pt-br', ptBR);

const ExcelModal = (props) => {
  const { formModal, setFormModal, execute, filterParams, recordCount } = props;
  const [focusedFilename, setFocusedFilename] = useState(false);
  const [loading, setLoading] = useState(false); // Estado para controlar o carregamento

  const getDefaultFilename = () => {
    const dataAtual = new Date();
    const dia = dataAtual.getDate();
    const mes = dataAtual.getMonth() + 1;
    const ano = dataAtual.getFullYear();
    const dataFormatada = `${dia}-${mes}-${ano}`;
    const fileNameDefault = `precatorio_exportado_${dataFormatada}`;
    return fileNameDefault;
  };

  const [filename, setFilename] = useState(getDefaultFilename());

  const handlerFilenameField = (e) => {
    const regex = /[^a-zA-Z0-9-_]/g;
    setFilename(e.target.value.replace(regex, ""));
  };

  // Função para executar a exportação
  const handleExport = async (e) => {
    setLoading(true); // Ativa o loader
    try {
      await execute(e, filterParams(), filename + ".xlsx"); // Aguarda a execução da exportação
      setFormModal(false);
    } catch (error) {
      console.error('Erro ao exportar:', error); // Tratamento de erro
    } finally {
      setLoading(false); // Desativa o loader
    }
  };

  return (
    <Modal
      className="modal-dialog-centered"
      size="sm"
      isOpen={formModal}
      toggle={() => setFormModal(false)}
    >
      <div className="modal-body p-0">
        <Card className="bg-secondary border-0 mb-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Defina o Nome do Arquivo Excel.</small>
              {recordCount > 0 && (
                <p style={{ marginTop: '8px', marginBottom: 0, fontSize: '0.85em', color: '#8898aa' }}>
                  Serão exportados {recordCount} registros. Exportações grandes podem levar alguns minutos.
                </p>
              )}
            </div>
            <Form role="form">
              <FormGroup
                className={classnames("mb-3", {
                  focused: focusedFilename,
                })}
              >
                <InputGroup className="input-group-merge input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-bold-right" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="FileName"
                    type="text"
                    onFocus={() => setFocusedFilename(true)}
                    onBlur={() => setFocusedFilename(false)}
                    onChange={handlerFilenameField}
                    value={filename}
                  />
                </InputGroup>
              </FormGroup>
              <div className="text-center">
                <Button
                  className="my-4"
                  color="primary"
                  type="button"
                  onClick={handleExport}
                  disabled={loading || filename.length === 0} // Desativa o botão enquanto carrega
                >
                  {loading ? 'Exportando...' : 'Extrair'} {/* Mostra o texto ou o loader */}
                </Button>
                {!loading && ( // Oculta o botão "Nome Padrão" durante o carregamento
                    <Button
                    className="my-4"
                    color="primary"
                    type="button"
                    onClick={() => setFilename(getDefaultFilename())}
                    >
                    Nome Padrão
                    </Button>
                )}
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </Modal>
  );
};

export const DuelistFilter = (props) => {
    const notify = props.showToast || (() => {});
    
    const { reload, endpoint, orderStatus, isOpen, getFilters, executeExport, recordCount } = props;

    const [filterValue, setFilterValue] = useState({
        field: "",
        value: "",
        values: []
    });
    const [filters, setFilters] = useState([]);
    const [filterState, setFilterState] = useState(isOpen);
    const openFilterState = () => setFilterState(true);
    const closeFilterState = () => setFilterState(false);

    const [statusMode, setStatusMode] = useState(false);
    const openStatusMode = () => setStatusMode(true);
    const closeStatusMode = () => setStatusMode(false);
    

    
    const [likeMode, setLikeMode] = useState(true);
    const openLikeMode = () => setLikeMode(true);
    const closeLikeMode = () => setLikeMode(false);

    const [filterType, setFilterType] = useState("string");

    const [keyMore, setKeyMore] = useState(null);

    const [inputTextValue, setInputTextValue] = useState("");
    const [select2Key, setSelect2Key] = useState(0);

    const setFilterValueDebounced = useMemo(
        () => debounce((newValue) => {
            setFilterValue(prev => ({ ...prev, value: newValue }));
        }, 300),
        []
    );

    useEffect(() => {
        return () => setFilterValueDebounced.cancel();
    }, [setFilterValueDebounced]);

    const select2Data = useMemo(
        () => allFilterOptions.map((fieldData) => ({ text: fieldData.name, id: fieldData.field })),
        []
    );

    const [ formModal, setFormModal ] = useState(false);
    const openModal = () => {
        setFormModal(true);
    }

    const handlerInputFilter = (e) => {
        if (e instanceof Date || e === null) {
            if (!e) return setFilterValue({...filterValue, "value": ""});
            const day = String(e.getDate()).padStart(2, "0");
            const month = String(e.getMonth() + 1).padStart(2, "0");
            const year = e.getFullYear();
            return setFilterValue({...filterValue, "value": `${day}/${month}/${year}`});
        }

        const name = e.target.name;
        const value = e.target.value;

        let filterObject = null;
        if(name === "field"){
            if (!value) return;
            filterObject = allFilterOptions.find((filterItem) => filterItem.field === value);
            if (filterObject) {
                setTimeout(() => {
                    setFilterType(filterObject.type);
                    if (value === "status__name") {
                        setFilterValue(prev => ({...prev, field: value}));
                        openStatusMode();
                    } else {
                        closeStatusMode();
                        setFilterValue(prev => ({...prev, field: value}));
                    }
                }, 0);
            }
            return;
        }

        // if (e.target.type === "checkbox") return setFilterValue({...filterValue, [name]: e.target.checked});
        if (name === "value" && (filterType === "string" || filterType === "float" || filterType === "year")) {
            setInputTextValue(value);
            setFilterValueDebounced(String(value).replace("not__", ""));
            return;
        }
        return setFilterValue({...filterValue, [name]: String(value).replace("not__", "")});
    }

    const clearFilterInputValue = () => {
        setInputTextValue("");
        setFilterValue({...filterValue, "value": ""});
    }

    const addFilter = () => {
        if (!filterValue.field) return notify("warning", "Insira um filtro para pesquisar.");
        // if (!filterValue.value && filterValue.field != "previsionWeek") return window.alert("Insert a value or and a filter to search.");
        let filterField = allFilterOptions.find((filterItem) => filterItem.field === filterValue.field);
        // filterField = filterField[0];

        let filterData = {...filterValue};
        filterData.value = filterType === "boolean" && filterData.value === "" ? false : filterData.value;

        if (filterField){
            if (filterType !== "boolean"){
                filterData.value = likeMode ? filterData.value : `not__${filterData.value}`;
            } else {
                filterData.value = likeMode ? filterData.value : !(filterData.value);
            }
        }

        filterData.field = filterField;
        filterData.status = likeMode;
        filterData.type = String(filterType);
        setFilters([...filters, filterData]);
        // filterData.values = [filterType === "boolean" && filterData.value === "" ? false : filterData.value];

        // // const copyFilters = filters.filter((item) => item.field[0] === filterValue.field);
        // // if (copyFilters.length > 0) return window.alert("Filter name has exist.");
        // let filterFiltered = filters.filter((filterItem) => filterItem.field[0].replace("not__", "") === filterData.field[0]);
        // if(filterFiltered.length > 0) {
        //     filterFiltered = filterFiltered[0];
        //     const filtersCopy = [...filters];
        //     const filterFilteredIndex = filtersCopy.indexOf(filterFiltered[0]);

        //     filterFiltered.values.push(filterData.value)
        //     filterFiltered.status.push(likeMode);

        //     filtersCopy[filterFilteredIndex] = filterFiltered;
        // } else {
        //     setFilters([...filters, filterData]);
        // }
        
        setInputTextValue("");
        setFilterValue({
            field: "",
            value: "",
            values: []
        });
        setSelect2Key(prev => prev + 1);
        openLikeMode();

        closeStatusMode();
        // setFilterType(null);
    }

    const deleteFilter = (e) => {
        const index = e.target.value;
        let copyFilters = [...filters];

        copyFilters.splice(index, 1);

        setFilters(copyFilters);
        if(getFilters) getFilters(copyFilters);
    }

    const editFilter = (index) => {
        let filterItem = filters[index];
        setFilterType(filterItem.type);

        if ( filterItem.type !== "boolean" ){
            const editValue = String(filterItem.value).replace("not__", "");
            setFilterValue({
                field: filterItem.field.field,
                value: editValue
            });
            if (filterItem.type === "string" || filterItem.type === "float") {
                setInputTextValue(editValue);
            }
        } else {
            setFilterValue({
                field: filterItem.field.field,
                value: filterItem.value
            });
        }
        setLikeMode(filterItem.status);
        setSelect2Key(prev => prev + 1);
        deleteFilter({ target: { value: index } });
        if(filterItem.field.field === "process_status") openStatusMode();
    }

    function convertFiltersToQueryString() {
        return filters.map(item => `${encodeURIComponent(item.field.field)}=${encodeURIComponent(item.value)}`).join('&');
    }

    const searchFilters = () => {
        const filtersURI = convertFiltersToQueryString();
        const url = `/process/search/?${filtersURI}`;
        reload(url);
    }

    const handleKeyPress = (e) => {
        if (e.key === "Control") setKeyMore('Control');
        if (e.key === "Enter" && !keyMore) return addFilter();
        if (e.key === "Enter" && keyMore === "Control") {
            setKeyMore(null);
            return searchFilters();
        }
    }

    const handleKeyUp = (e) => {
        if (keyMore) setKeyMore(null);
    }
    
    return (
        <>
        <div id="container-duelist-filter" className={filterState ? "container-duelist-filter-opened" : "container-duelist-filter-closed"}>
            <div id="container-duelist-filter-itens">
                {!(isOpen) ? (
                    <div id="container-duelist-filter-button" className="d-flex align-items-center mb-3" style={{ gap: '10px' }}>
                        {filterState ? (
                            <Button color="default" size="sm" outline type="button" onClick={closeFilterState}>
                                <i className="ni ni-bold-up mr-1" />
                                Ocultar Filtro
                            </Button>
                        ) : (
                            <Button color="primary" size="sm" type="button" onClick={openFilterState}>
                                <i className="ni ni-zoom-split-in mr-2" />
                                Filtrar Resultados
                            </Button>
                        )}
                        {endpoint && endpoint.includes("?") && !endpoint.includes("page=") ? (
                            <Button color="default" onClick={() => { setFilters([]); setSelect2Key(prev => prev + 1); reload("/process/search/"); }} outline size="sm" type="button">
                                Limpar
                            </Button>
                        ): null}
                        <Button color="primary" size='sm' outline type='button' onClick={openModal} className="ml-auto">
                            <i className="ni ni-cloud-download-95 mr-2" />
                            Exportar Excel
                        </Button>
                    </div>
                ):null}
                <ExcelModal formModal={formModal} setFormModal={setFormModal} execute={executeExport} filterParams={convertFiltersToQueryString} recordCount={recordCount} />
                <div id="container-duelist-filter-input" onKeyDownCapture={handleKeyPress} onKeyUpCapture={handleKeyUp} tabIndex="0">
                    {/* <Input id="duelist-filter-input-select" onChange={handlerInputFilter} value={filterValue.field} name='field' bsSize="sm" type="select">
                        <option value="">Fields</option>
                        {filterOnlyFields.map((field, index) => (<option key={`filter-field-${index}`} value={field}>{field}</option>))}
                        {allFilterOptions.map((fieldData, index) => (<option key={`filter-field-${index}`} value={fieldData.field}>{fieldData.name}</option>))}
                    </Input> */}
                    <div id="duelist-filter-input-select">
                        <Select2
                            key={select2Key}
                            className="form-control"
                            name="field"
                            options={{ placeholder: "Select a field" }}
                            onSelect={handlerInputFilter}
                            data={select2Data}
                            value={filterValue.field}
                            multiple={false}
                            onOpen={() => {
                                const select2 = document.getElementsByClassName('select2-search__field');
                                select2[0].focus();
                            }}
                            onClose={() => {
                                const body = document.querySelector("body");
                                body.tabIndex = 0;
                                body.focus();
                            }}
                        />
                    </div>
                    {filterType === "boolean" ? (
                        <div className="custom-control custom-checkbox duelist-filter-input-checkbox">
                            <input
                                className="custom-control-input"
                                id="value"
                                name='value'
                                type="checkbox"
                                onClick={handlerInputFilter}
                                defaultChecked={filterValue.value ? true : false}
                            />
                            <label className="custom-control-label" htmlFor="value">
                                Valor
                            </label>
                        </div>
                    ): filterType === "date" ? (
                        <div id='duelist-filter-input-select-status' onDoubleClick={clearFilterInputValue}>
                            <DatePicker
                            locale="pt-br"
                            onChange={handlerInputFilter}
                            selected={(() => {
                                if (!filterValue.value) return null;
                                const parts = filterValue.value.split('/');
                                if (parts.length === 3) return new Date(parts[2], parts[1] - 1, parts[0]);
                                return null;
                            })()}
                            dateFormat="dd/MM/yyyy"
                            isClearable={true}/>
                        </div>
                    ) : filterType === "year" ? (
                        <Input
                            id="duelist-filter-input-year"
                            onChange={handlerInputFilter}
                            value={inputTextValue}
                            name='value'
                            type="number"
                            min="1900"
                            max="2100"
                            placeholder="Ex: 2024"
                            bsSize="sm"
                        />
                    ) : (filterType === "string" || filterType === "float") ? (
                        <Input id="duelist-filter-input-text" onChange={handlerInputFilter} value={inputTextValue} name='value' type="text" bsSize="sm"/>
                    ) : filterType === "select" && (
                        <>
                            {statusMode && (
                                <>
                                    <Input id="duelist-filter-input-select-status" name='value' value={filterValue.value} onChange={handlerInputFilter} bsSize="sm" type="select">
                                        <option value="">Orders status</option>
                                        {orderStatus.sort((a, b) => a.name - b.name).map((item, index) => (<option key={`filter-status-${index}`} value={item.name}>{item.name}</option>))}
                                    </Input>
                                </>
                            )}
                        </>
                    )}
                    <div id="duelist-filter-container-buttons">
                        <Button id="duelist-filter-button-like" className='duelist-filter-button' color={likeMode ? "primary":"danger"} onClick={likeMode ? closeLikeMode:openLikeMode} size="sm" type="button">
                            {likeMode?"Contém":"Não Contém"}
                        </Button>
                        <Button id="duelist-filter-button-add" className="duelist-filter-button" onClick={addFilter} color="primary" size="sm" type="button">
                            Adicionar
                        </Button>
                        <Button id="duelist-filter-button-search" className="duelist-filter-button" onClick={searchFilters} color="primary" size="sm" type="button">
                            Pesquisar
                        </Button>
                        <UncontrolledTooltip
                            delay={0}
                            placement="bottom"
                            target="duelist-filter-button-add"
                        >
                            Aperte <b>"ENTER"</b> para adicionar um filtro.
                        </UncontrolledTooltip>
                        <UncontrolledTooltip
                            delay={0}
                            placement="bottom"
                            target="duelist-filter-button-search"
                        >
                            Aperte <b>"CTRL + ENTER"</b> para pesquisar.
                        </UncontrolledTooltip>
                    </div>
                </div>
                <div className='duelist-filter-container-bubble'>
                    {filters.map((filterItem, index) => 
                        (
                            <div key={`${index}-filter`} onDoubleClick={() => editFilter(index)} className={filterItem.status?'duelist-filter-bubble':'duelist-filter-bubble-not-like'}>
                                <div className='duelist-filter-bubble-title'>
                                    {filterItem.field.name}:&nbsp;
                                </div>
                                <div>
                                    {
                                        filterItem.value.length === 0 ? "Empty":
                                        filterItem.type === "string" ? filterItem.value.replace("not__", "") :
                                        filterItem.type === "float" ? filterItem.value.replace("not__", "") :
                                        filterItem.type === "boolean" ? filterItem.value ? "Yes" : "No":
                                        filterItem.type === "date" ? String(formatDate(filterItem.value)).replace("not__", ""):
                                        filterItem.type === "year" ? String(filterItem.value).replace("not__", ""):
                                        filterItem.type === "select" && filterItem.value.replace("billed", "Green").replace("undefined", "White").replace("transport", "Yellow").replace("not__", "")
                                    }
                                    &nbsp;
                                </div>
                                <Button color='danger' outline onClick={deleteFilter} value={index} className='button-filter-bubble-delete' size='sm'>
                                    x
                                </Button>
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
        </>
    )
}
